module.exports = __webpack_public_path__ + "static/strafe1-f8452ba57a105e42a220af2b2f3c2d62.mp4";